module.exports = __webpack_public_path__ + "img/img16.c98e29fb.png";